// 提供 Store 何種收款方式

export const DIRECT = 'direct' // 非代收代付
export const AGENCY = 'agency' // 代收代付
export const MIXTURE = 'mixture' // 混合型
